export default function FormatNumberLawsuit(v) {
  if (v.lenght > 25) return v;

  v = v.replace(/\D/g, "");
  v = v.replace(/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/g, "$1-$2.$3.$4.$5.$6");

  return v;
}
